import { memo } from "react";
import { Body, WizardFooter } from "../../styles/Emissao";
import PurchaseContent from "./PurchaseContent";
import PurchaseFooter from "./PurchaseFooter";

const WizardStepsPurchaseTaxNote = ({ step = 0 }) => {
  return (
    <>
      <Body>
        <PurchaseContent step={step} />
        <WizardFooter>
          <PurchaseFooter step={step} />
        </WizardFooter>
      </Body>
    </>
  );
};

export default memo(WizardStepsPurchaseTaxNote);
